import axios from '@axios'
import config from '@core/app-config/api-config'

const base = `${config.host}/bib-recognition`

/** The bib recognition queue (admins only); its limits are settings of the bib_recognition category */
const bibRecognitionApi = {
  getStats(startId) {
    return axios.get(`${base}/stats`, { params: { start_id: startId || undefined } })
  },
  getService() {
    return axios.get(`${base}/service`)
  },
  startService() {
    return axios.post(`${base}/service/start`)
  },
  stopService() {
    return axios.post(`${base}/service/stop`)
  },
  getStarts() {
    return axios.get(`${base}/starts`)
  },
  getJobs(params) {
    return axios.get(`${base}/jobs`, { params })
  },
  enqueueStart(startId, payload = {}) {
    return axios.post(`${base}/starts/${startId}/enqueue`, payload)
  },
  retagStart(startId) {
    return axios.post(`${base}/starts/${startId}/retag`)
  },
  setStartPriority(startId, priority) {
    return axios.put(`${base}/starts/${startId}/priority`, { priority })
  },
  enqueuePhoto(photoId, payload = {}) {
    return axios.post(`${base}/photos/${photoId}/enqueue`, payload)
  },
  retryFailed(startId) {
    return axios.post(`${base}/jobs/retry-failed`, { start_id: startId || undefined })
  },
  cancelPending(startId) {
    return axios.post(`${base}/jobs/cancel-pending`, { start_id: startId || undefined })
  },
}

export default bibRecognitionApi
